import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "../layout/Layout"; // Isko pichle step ke hisab se import karein
import Home from "../pages/Home";
import About from "../pages/who we are/About";
import Donate from "../pages/Donate";
import Campaign from "../pages/Campaign";
import Contact from "../pages/Contact";
import Checkout from "../pages/Checkout";
import AdminRoutes from "./AdminRoutes";
import CookieConsent from "../components/common/CookieConsent";
import Objectives from "../pages/who we are/Objectives";
import PhotoGallery from "../pages/blogs & stories/PhotoGallery";
import VideoGallery from "../pages/blogs & stories/VideoGallery";
import Blogs from "../pages/blogs & stories/Blogs";
import BlogDetail from "../pages/blogs & stories/BlogDetail";
import ChildEducation from "../pages/what we do/ChildEducation";
import TreePlantation from "../pages/what we do/TreePlantation";
import HungerSupport from "../pages/what we do/HungerSupport";
import WomenEmpowerment from "../pages/what we do/WomenEmpowerment";
import OldAgeHomes from "../pages/what we do/OldAgeHomes";
import MedicalBloodDonation from "../pages/what we do/MedicalBloodDonation";

import Career from "../pages/get involved/Career";
import BecomeVolunteer from "../pages/get involved/BecomeVolunteer";
import TermsConditions from "../pages/footer pages/TermsConditions";
import RefundPolicy from "../pages/footer pages/RefundPolicy";
import DonationPolicy from "../pages/footer pages/DonationPolicy";
import CSRPolicies from "../pages/footer pages/CSRPolicies";
import GrievancePolicy from "../pages/footer pages/GrievancePolicy";
import VisionValues from "../pages/footer pages/VisionValues";
import GovernanceLeadership from "../pages/footer pages/GovernanceLeadership";
import TransparencyAccountability from "../pages/footer pages/TransparencyAccountability";
import PrivacyPolicy from "../pages/footer pages/PrivacyPolicy";
import DisclaimerPolicy from "../pages/footer pages/DisclaimerPolicy";

import VolunteerTerms from "../pages/footer pages/VolunteerTerms";
import ChildProtectionPolicy from "../pages/footer pages/ChildProtectionPolicy";
import ScrollToTop from "../components/ScrollToTop";
import CSROpportunities from "../pages/get involved/CSROpportunities";
import OurTeam from "../pages/OurTeam";
import LegalDocs from "../pages/LegalDocs";
import DonorProfile from "../pages/DonorProfile";
import NotFound from "../pages/NotFound";



const AppRoutes = () => {
  return (
    <BrowserRouter>
    <ScrollToTop/>
      <Routes>

       
          {/* --- ADMIN ROUTES (Separate Interface) --- */}
        {/* "/*" lagana zaruri hai taaki react-router samajh sake ki aage nested routes hain */}
        <Route path="/n-jio-sevaa/*" element={<AdminRoutes />} />
        
        {/* Parent Route with Layout */}
        <Route path="/" element={<Layout />}>
        
          
          {/* Ye saare pages Layout ke <Outlet /> ki jagah render honge */}
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
           <Route path="objectives" element={<Objectives />} />
          <Route path="donate" element={<Donate />} />
          <Route path="campaign" element={<Campaign />} />
          <Route path="contact" element={<Contact />} />
          <Route path="checkout" element={<Checkout />} />
          <Route path="photo-gallery" element={<PhotoGallery />} />
          <Route path="video-gallery" element={<VideoGallery />} />
          <Route path="blogs" element={<Blogs />} />
          <Route path="blog/:id" element={<BlogDetail />} />
          <Route path="child-education" element={<ChildEducation />} />
          <Route path="tree-plantation" element={<TreePlantation />} />
          <Route path="hunger-support" element={<HungerSupport />} />
          <Route path="women-empowerment" element={<WomenEmpowerment />} />
          <Route path="old-age-homes" element={<OldAgeHomes />} />
          <Route path="medical-blood-donation" element={<MedicalBloodDonation />} />
          <Route path="csr" element={<CSROpportunities />} />
          <Route path="career" element={<Career />} />
          <Route path="volunteer" element={<BecomeVolunteer />} />


          {/* footer pages */}
          <Route path="vision-values" element={<VisionValues />} />
          <Route path="governance-leadership" element={<GovernanceLeadership />} />
          <Route path="transparency-accountability" element={<TransparencyAccountability />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="terms-conditions" element={<TermsConditions />} />
          <Route path="refund-policy" element={<RefundPolicy />} />
          <Route path="disclaimer" element={<DisclaimerPolicy />} />
          <Route path="donation-policy" element={<DonationPolicy />} />
          <Route path="child-protection" element={<ChildProtectionPolicy />} />
          <Route path="volunteer-terms" element={<VolunteerTerms />} />
          <Route path="csr-policy" element={<CSRPolicies />} />
          <Route path="grievance" element={<GrievancePolicy />} />

          <Route path="our-team" element={<OurTeam />} />
          <Route path="legal-documents" element={<LegalDocs />} />

          <Route path="/donor-profile" element={<DonorProfile />} />

          {/* Permanent URL aliases retained for old indexed links. Server .htaccess also redirects them. */}
          <Route path="ar" element={<Navigate to="/" replace />} />
          <Route path="terms-and-conditions" element={<Navigate to="/terms-conditions" replace />} />
          <Route path="csr-partnership-policy" element={<Navigate to="/csr-policy" replace />} />
          <Route path="child-protection-policy" element={<Navigate to="/child-protection" replace />} />
          <Route path="disclaimer-policy" element={<Navigate to="/disclaimer" replace />} />
          <Route path="grievance-contact" element={<Navigate to="/grievance" replace />} />

          <Route path="*" element={<NotFound />} />

        
          
        </Route>
      </Routes>
      <CookieConsent />
    </BrowserRouter>
  );
};

export default AppRoutes;